// extracted by mini-css-extract-plugin
export default {"container":"styles_container__RVJTq","loader":"styles_loader__6MWf2","spin":"styles_spin__kk691"};